function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { _baseBadgeTheme, _baseCalendarTheme, _baseFileUploadTheme, _baseSheetTheme, _descriptionTheme, _imageIconTheme, _labelTheme, _mainLabelTheme, _paragraphListTheme, _paragraphTheme, _sectionLabelTheme, _tableAmountInputTheme, _tableDataCellTheme, _tableHeaderBaseCellTheme, actionBarTheme, amountInputTheme, avatarGroupTheme, avatarImageControlTheme, avatarTheme, avatarWithDetailsTheme, baseIconTheme, basePopoverTheme, baseSelectTheme, baseVirtualCardDetailsTheme, baseVirtualCardTheme, beaconTheme, blanketTheme, brandSymbolTheme, brandTheme, buttonTheme, calendarLegendTheme, calendarTheme, checkboxTheme, chipTheme, circularProgressTheme, counterTheme, currencyTheme, customInputContainerTheme, dateFieldTheme, datePickerTheme, deprecatedSearchBarTheme, deprecatedTabsTheme, dividerTheme, fileAttachmentTheme, flagIconTheme, floatingButtonTheme, formErrorTheme, formFieldTheme, formTheme, iconButtonTheme, imageTheme, interactiveButtonTheme, linearProgressTheme, linkTheme, lottieTheme, nakedButtonTheme, navigationItemTheme, paginationTheme, radioGroupTheme, radioTheme, searchBarTheme, sectionBannerTheme, securedTextFieldTheme, selectMessageTheme, selectNewTheme, selectOptionTheme, selectTheme, skeletonCircleTheme, skeletonTextTheme, skeletonTheme, statusBarTheme, statusIndicatorTheme, switchTheme, tableAmountCellTheme, tableCellTheme, tableHeaderCellTheme, tableHeaderSortableCellTheme, tableMenuTriggerHeaderCellTheme, tableMobileContainerTheme, tableSelectCellTheme, tableTheme, tabsTheme, textAreaTheme, textFieldTheme, textTheme, toastTheme, tooltipTheme, trackerStepTheme, trackerTheme, verificationCodeFieldTheme, virtualCardTheme } from '../components/components.theme';
import { formLineItemsTheme } from '../components/form/components/forms.theme';
import { _baseMenuTriggerTheme, _menuFooterTheme, _menuTitleTheme, _menuTriggerTheme, _mobileMenuDropdownTheme, accordionTheme, baseMenuTheme, baseModalTheme, cardTheme, collapsibleCardTheme, collapsibleTheme, containerTheme, drawerTheme, groupItemTheme, groupTheme, loadingContainerTheme, menuItemTheme, promotionalModalTheme, stackedContainerTheme } from '../containers/containers.theme';
import { illustrationTheme, loaderTheme, logoTheme } from '../foundations/foundations.theme';
import { externalLayoutTheme, layoutTheme, splitScreenTheme } from '../layouts/layouts.theme';
var SingleStyleConfigComponents = {
  _BaseBadge: _baseBadgeTheme,
  Chip: chipTheme,
  Counter: counterTheme,
  _Description: _descriptionTheme,
  _MenuTitle: _menuTitleTheme,
  MenuItem: menuItemTheme,
  _MenuFooter: _menuFooterTheme,
  BaseIcon: baseIconTheme,
  FlagIcon: flagIconTheme,
  BrandSymbol: brandSymbolTheme,
  Brand: brandTheme,
  Calendar: calendarTheme,
  FloatingButton: floatingButtonTheme,
  _SectionLabel: _sectionLabelTheme,
  Illustration: illustrationTheme,
  Link: linkTheme,
  Logo: logoTheme,
  Lottie: lottieTheme,
  NakedButton: nakedButtonTheme,
  NavigationItem: navigationItemTheme,
  RadioGroup: radioGroupTheme,
  Tracker: trackerTheme,
  TableCell: tableCellTheme,
  _TableHeaderBaseCell: _tableHeaderBaseCellTheme,
  _TableDataCell: _tableDataCellTheme,
  TableHeaderCell: tableHeaderCellTheme,
  TableMenuTriggerHeaderCell: tableMenuTriggerHeaderCellTheme,
  _MenuTrigger: _menuTriggerTheme,
  _ImageIcon: _imageIconTheme,
  Container: containerTheme,
  Card: cardTheme,
  Group: groupTheme,
  Skeleton: skeletonTheme,
  SkeletonCircle: skeletonCircleTheme,
  SkeletonText: skeletonTextTheme,
  GroupItem: groupItemTheme,
  Text: textTheme
};
var MultiStyleConfigComponents = {
  AmountInput: amountInputTheme,
  BaseModal: baseModalTheme,
  _BaseSheet: _baseSheetTheme,
  _Paragraph: _paragraphTheme,
  _ParagraphList: _paragraphListTheme,
  _MainLabel: _mainLabelTheme,
  _Label: _labelTheme,
  TextArea: textAreaTheme,
  Input: textFieldTheme,
  BaseSelect: baseSelectTheme,
  Accordion: accordionTheme,
  Avatar: avatarTheme,
  Button: buttonTheme,
  Checkbox: checkboxTheme,
  _BaseCalendar: _baseCalendarTheme,
  CalendarLegend: calendarLegendTheme,
  Currency: currencyTheme,
  _BaseFileUpload: _baseFileUploadTheme,
  DateField: dateFieldTheme,
  Divider: dividerTheme,
  DatePicker: datePickerTheme,
  Collapsible: collapsibleTheme,
  CollapsibleCard: collapsibleCardTheme,
  FormError: formErrorTheme,
  FormField: formFieldTheme,
  Form: formTheme,
  IconButton: iconButtonTheme,
  Image: imageTheme,
  InteractiveButton: interactiveButtonTheme,
  AvatarWithDetails: avatarWithDetailsTheme,
  Pagination: paginationTheme,
  BasePopover: basePopoverTheme,
  Beacon: beaconTheme,
  LinearProgress: linearProgressTheme,
  CircularProgress: circularProgressTheme,
  Radio: radioTheme,
  PromotionalModal: promotionalModalTheme,
  DeprecatedSearch: deprecatedSearchBarTheme,
  SearchBar: searchBarTheme,
  Select: selectTheme,
  SelectOption: selectOptionTheme,
  SelectMessage: selectMessageTheme,
  Switch: switchTheme,
  DeprecatedTabs: deprecatedTabsTheme,
  Tabs: tabsTheme,
  Toast: toastTheme,
  Table: tableTheme,
  TableMobileContainer: tableMobileContainerTheme,
  TableSelectCell: tableSelectCellTheme,
  TableHeaderSortableCell: tableHeaderSortableCellTheme,
  _TableAmountInput: _tableAmountInputTheme,
  Tooltip: tooltipTheme,
  TrackerStep: trackerStepTheme,
  SectionBanner: sectionBannerTheme,
  StatusBar: statusBarTheme,
  AvatarImageControl: avatarImageControlTheme,
  FileAttachment: fileAttachmentTheme,
  TableAmountCell: tableAmountCellTheme,
  CustomInputContainer: customInputContainerTheme,
  LoadingContainer: loadingContainerTheme,
  Loader: loaderTheme,
  Drawer: drawerTheme,
  StatusIndicator: statusIndicatorTheme,
  AvatarGroup: avatarGroupTheme,
  VerificationCodeField: verificationCodeFieldTheme,
  Blanket: blanketTheme,
  ActionBar: actionBarTheme,
  _MobileMenuDropdown: _mobileMenuDropdownTheme,
  BaseVirtualCard: baseVirtualCardTheme,
  BaseVirtualCardDetails: baseVirtualCardDetailsTheme,
  VirtualCard: virtualCardTheme,
  _BaseMenuTrigger: _baseMenuTriggerTheme,
  SecuredTextField: securedTextFieldTheme,
  StackedContainer: stackedContainerTheme,
  SelectNew: selectNewTheme,
  // layouts
  ExternalLayout: externalLayoutTheme,
  SplitScreen: splitScreenTheme,
  Layout: layoutTheme,
  BaseMenu: baseMenuTheme,
  FormLineItems: formLineItemsTheme
};
export var components = _objectSpread(_objectSpread({}, MultiStyleConfigComponents), SingleStyleConfigComponents);
/* eslint-disable @typescript-eslint/no-explicit-any */
//# sourceMappingURL=components.js.map